import { formatDateTime } from "../functions/date-utils";

export function DateTooltip({ date, originalDate, className = "", onClick }) {
  return (
    <div className={`relative group ${className}`}>
      <span className="cursor-pointer" onClick={onClick}>
        {date}
      </span>
      <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-white text-gray-900 text-sm rounded-lg shadow-lg border border-gray-200 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap z-50">
        {formatDateTime(originalDate, "tooltip")}
        <div className="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-white"></div>
      </div>
    </div>
  );
}
